import React, { useState } from "react";
import Switch from "@mui/material/Switch";

const SwitchButton = ({ ...rest }) => {
  return (
    <>
      <div className="form-check form-switch">
        <input className="form-check-input" type="checkbox" role="switch" {...rest} />
      </div>
    </>
  );
};

export default SwitchButton;
